module.exports = __webpack_public_path__ + "front/img/31.00ff627b.png";